import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import { motion } from 'motion/react';
import { ArrowRight, CheckCircle2, Shield, Zap, Activity, BarChart3, Folder, Megaphone, Database, ShoppingCart, Globe, Users, Lock, Server } from 'lucide-react';

// Decorative banner shapes to match existing site look
import flutterHero from "../assets/images/middleware.jpg";







const CustomMiddlewarePlatform = () => {
  return (
    <>
      <style>{`
      
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');              .gcc-outfit { font-family: 'Outfit', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji'; }
  
  *{ font-family: "Outfit", sans-serif !important;}
        .cmp-hero-section { position: relative; padding: 70px 0; background: #fff; overflow: hidden; }
        .cmp-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.4; pointer-events:none; z-index:0; }
        @keyframes cmpOrb8 { 0%,100%{ transform: scale(1); opacity:.3; } 50%{ transform: scale(1.2); opacity:.5; } }
        @keyframes cmpOrb10 { 0%,100%{ transform: scale(1); opacity:.2; } 50%{ transform: scale(1.3); opacity:.4; } }
        .cmp-orb { position:absolute; border-radius:50%; filter: blur(100px); z-index:0; }
        // .cmp-orb-1 { top:-120px; left:-120px; width:600px; height:600px; background: radial-gradient(circle, rgba(238,0,0,0.25) 0%, rgba(238,0,0,0) 70%); animation: cmpOrb8 8s ease-in-out infinite; }
        // .cmp-orb-2 { right:-140px; bottom:-120px; width:500px; height:500px; background: radial-gradient(circle, rgba(238,0,0,0.18) 0%, rgba(238,0,0,0) 70%); animation: cmpOrb10 10s ease-in-out infinite; }
        .cmp-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 16px; background:#fff; border:1px solid #e2e8f0; border-radius:999px; box-shadow:0 2px 10px rgba(0,0,0,0.05); font-size:12px; font-weight:700; color:#0f172a; text-transform:uppercase; letter-spacing:1px; }
        .cmp-badge-dot { width:6px; height:6px; background:#ee0000; border-radius:50%; animation: cmpPulseDot 2s ease-in-out infinite; }
        @keyframes cmpPulseDot { 0%,100%{ transform: scale(1); } 50%{ transform: scale(1.3); } }
        .cmp-title { font-size:42px; font-weight:800; text-align:left; color:#0f172a; letter-spacing:-.5px; margin: 12px 0; }
        .cmp-highlight { color:#ee0000; }
        .cmp-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px 0 0; width:0; }
        .cmp-sub { font-size:18px; color:#475569; text-align:left; max-width:900px; margin: 14px 0 0; }
        .cmp-buttons { display:flex; gap:12px; justify-content:flex-start; margin-top: 22px; flex-wrap:wrap; }
        .btn-cmp-red, .btn-cmp-white { display:inline-flex; align-items:center; gap:8px; padding:13px 22px; border-radius:999px; font-weight:800; transition: transform .2s ease, box-shadow .2s ease; }
        .btn-cmp-red { background:#ee0000; color:#fff; border:none; box-shadow:0 20px 40px -20px rgba(238,0,0,0.55); }
        .btn-cmp-white { background:#fff; color:#ee0000; border:2px solid #ee0000; box-shadow:0 12px 24px -12px rgba(238,0,0,0.25); }
        .btn-cmp-red:hover, .btn-cmp-white:hover { transform: translateY(-2px) scale(1.05); }
        .btn-cmp-red:active, .btn-cmp-white:active { transform: scale(.98); }
        .btn-cmp-red svg, .btn-cmp-white svg { transition: transform .2s ease; }
        .btn-cmp-red:hover svg, .btn-cmp-white:hover svg { transform: translateX(4px); }
        .cmp-desc-box { max-width: 960px; margin: 30px 0 0; background: rgba(255,255,255,0.87); border:1px solid #ffd4d4; border-radius:16px; padding:18px 22px; backdrop-filter: blur(8px); color: #374151; }
        @media (max-width: 992px) { .cmp-title { font-size: 42px; } }
        @media (max-width: 768px) { .cmp-title { font-size: 34px; } .cmp-sub { font-size: 16px; } }
        .cmp-overview-section { position: relative; padding: 80px 0; background: #effdff; overflow: hidden; }
        .cmp-overview-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.35; pointer-events:none; z-index:0; }
        .cmp-overview-title { font-size:42px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px; }
        .cmp-overview-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px auto 0; width:0; }
        .cmp-overview-text { font-size:18px; color:#475569; text-align:center; max-width:1000px; margin:14px auto 0; line-height:30px; }
        @media (max-width: 992px) { .cmp-overview-title { font-size: 40px; } }
        @media (max-width: 768px) { .cmp-overview-title { font-size: 32px; } .cmp-overview-text { font-size:16px; } }
        .cmp-highlights-section { position: relative; padding: 80px 0; background: #fff; overflow: hidden; }
        .cmp-highlights-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.3; pointer-events:none; z-index:0; }
        .cmp-highlights-title { font-size:42px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px; }
        .cmp-highlights-underline { height:4px; background:#ee0000; border-radius:2px; margin:10px auto 0; width:0; }
        .highlight-card { position:relative; background:#fff; border-radius:24px;  box-shadow: 0 8px 18px rgba(0,0,0,0.06); padding:22px; transition: transform .3s ease, box-shadow .3s ease; }
        .highlight-card:hover { transform: translateY(-8px) scale(1.02); box-shadow: 0 20px 40px rgba(238,0,0,0.15); }
        .highlight-row { margin-top: 18px; }
        .highlight-item { display:flex; align-items:center; gap:14px; }
        .highlight-icon { width:36px; height:36px; border-radius:50%; display:flex; align-items:center; justify-content:center; background:#fff5f5; color:#ee0000; border:1px solid #ffd4d4; font-size:0; }
        .highlight-text { width:calc(100% - 46px); font-size:16px; color:#111827; font-weight:700; }
        .highlight-card:hover .highlight-text { color:#ee0000; }
        @media (max-width: 992px) { .cmp-highlights-title { font-size: 36px; } }
        @media (max-width: 768px) { .cmp-highlights-title { font-size: 30px; } .highlight-text { font-size:15px; } }
        .cmp-why-section { position: relative; padding: 80px 0; background: #e2f1fe;text-align: center; overflow: hidden; }
        .cmp-why-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.3; pointer-events:none; z-index:0; }
        .cmp-why-title { font-size:42px; font-weight:800; color:#0f172a; letter-spacing:-.5px; margin-bottom: 10px; }
        .cmp-why-underline { height:4px; background:#ee0000; border-radius:2px; width:0; margin: 12px 0 0; }
        .cmp-why-text { font-size:18px; margin:0 auto; color:#475569; line-height:30px; max-width: 980px; }
        @media (max-width: 992px) { .cmp-why-title { font-size: 40px; } }
        @media (max-width: 768px) { .cmp-why-title { font-size: 32px; } .cmp-why-text { font-size:16px; } }
        .cmp-benefits-section { position: relative; padding: 80px 0; background: #fff; overflow: hidden; }
        .cmp-benefits-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.3; pointer-events:none; z-index:0; }
        .cmp-benefits-title { font-size:42px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px; margin-bottom: 20px; margin-bottom: 40px; }
        .cmp-benefits-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px auto 0; width:0; }
        .benefit-card { position:relative; background:#fff; border-radius:22px; box-shadow: 0 8px 18px rgba(0,0,0,0.06); padding:24px; transition: transform .3s ease, box-shadow .3s ease; }
        .benefit-card:hover { transform: translateY(-10px) scale(1.02); box-shadow: 0 22px 40px rgba(238,0,0,0.12); }
        .benefit-icon { width:64px; height:64px; border-radius:12px; display:flex; align-items:center; justify-content:center; background: #ee0000;
  color: #fff;
  border: none;
  margin-bottom: 20px;
  box-shadow: 0 20px 40px -20px rgba(238,0,0,0.55); }
        @keyframes cmpIconGlow { 0% { box-shadow: 0 0 0 rgba(238,0,0,0); } 100% { box-shadow: 0 0 12px rgba(238,0,0,0.45); } }
        .benefit-icon { animation: cmpIconGlow 3s ease-in-out infinite alternate; }
        .benefit-title { font-size:18px; font-weight:800; color:#111827; margin:8px 0 6px; }
        .benefit-text { font-size:15px; color:#475569; line-height:26px; }
        @media (max-width: 992px) { .cmp-benefits-title { font-size: 40px; } }
        @media (max-width: 768px) { .cmp-benefits-title { font-size: 32px; } .benefit-title { font-size:17px; } .benefit-text { font-size:14px; } }
        .cmp-connectors-section { position: relative; padding: 80px 0; background:#effdff; overflow: hidden; }
        .cmp-connectors-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.3; pointer-events:none; z-index:0; }
        .cmp-connectors-title { font-size:42px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px;margin-bottom: 30px; }
        .cmp-connectors-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px auto 0; width:0; }
        .connector-card { position:relative; background: linear-gradient(135deg, #f7f9fc 0%, #ffffff 60%); border:1px solid #e5e7eb; border-radius:22px; box-shadow: 0 8px 18px rgba(0,0,0,0.06); padding:22px; transition: transform .3s ease, box-shadow .3s ease, border-color .3s ease; }
        .connector-card:hover { transform: translateY(-5px); box-shadow: 0 20px 40px rgba(238,0,0,0.15); border-color:#ee0000; }
        .connector-icon-box { width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; background:#ee0000; color:#fff; flex-shrink:0; }
        .connector-title { font-size:18px; font-weight:800; color:#111827; margin:4px 0 10px; transition: color .3s ease; }
        .connector-card:hover .connector-title { color:#ee0000; }
        .connector-chip-row { display:flex; flex-wrap:wrap; gap:10px; }
        .connector-chip { font-size:12px; color:#0f172a; background:#f1f5f9; border:1px solid #e2e8f0; border-radius:999px; padding:6px 14px; }
        @media (max-width: 992px) { .cmp-connectors-title { font-size: 40px; } }
        @media (max-width: 768px) { .cmp-connectors-title { font-size: 32px; } .connector-title { font-size:17px; } .connector-chip { font-size:13px; } }
        .cmp-usecases-section { position: relative; padding: 80px 0; background: #fff; overflow: hidden; }
        .cmp-usecases-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.25; pointer-events:none; z-index:0; }
        .cmp-usecases-title { font-size:42px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px; }
        .cmp-usecases-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px auto 0; width:0; }
        .usecase-card { position:relative; background:#fff; border:1px solid #e5e7eb; border-radius:22px; box-shadow: 0 8px 18px rgba(0,0,0,0.06); padding:22px; transition: transform .3s ease, box-shadow .3s ease, border-color .3s ease; }
        .usecase-card:hover { transform: translateY(-8px) scale(1.02); box-shadow: 0 20px 40px rgba(238,0,0,0.15); border-color:#ee0000; }
        .usecase-number { position:absolute; top:18px; right:18px; background: rgba(238,0,0,0.1); color:#0f172a; font-weight:800; font-size:12px; border-radius:999px; padding:6px 10px; }
        .usecase-icon-container { position:relative; width:48px; height:48px; }
        .usecase-icon-box { position:relative; width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; background:#ee0000; color:#fff; z-index:2; }
        .usecase-icon-glow { position:absolute; inset:0; border-radius:12px; background:#ee0000; filter: blur(18px); opacity:.3; z-index:1; }
        @keyframes usecaseGlow { 0% { transform: scale(1); opacity: .3; } 100% { transform: scale(1.1); opacity: .5; } }
        .usecase-icon-glow { animation: usecaseGlow 3s ease-in-out infinite alternate; }
        .usecase-title { font-size:18px; font-weight:800; color:#2d2d2d; margin:6px 0 8px; transition: color .3s ease; }
        .usecase-card:hover .usecase-title { color:#ee0000; }
        .usecase-text { font-size:15px; color:#475569; line-height:26px; }
        @media (max-width: 992px) { .cmp-usecases-title { font-size: 40px; } }
        @media (max-width: 768px) { .cmp-usecases-title { font-size: 32px; } .usecase-title { font-size:17px; } .usecase-text { font-size:14px; } }
        .cmp-how-section { position: relative; padding: 80px 0; background: #e2f1fe; overflow: hidden; }
        .cmp-how-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.25; pointer-events:none; z-index:0; }
        .cmp-how-title { font-size:42px; margin-bottom: 40px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px; }
        .cmp-how-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px auto 0; width:0; }
        .how-diagram { display:flex; align-items:center; justify-content:center; gap:18px; flex-wrap:wrap; }
        .how-box { background:#f1f5f9; color:#0f172a; border-radius:999px; padding:10px 18px; font-weight:800; }
        .how-box-mid { background:#ee0000; color:#fff; border-radius:999px; padding:10px 18px; font-weight:800; }
        .how-arrow { color:#ee0000; font-weight:800; }
        .how-bullet { display:flex; align-items:flex-start; gap:12px; }
        .how-bullet-icon { width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; background:#fff5f5; color:#ee0000; border:1px solid #ffd4d4; flex-shrink:0; }
        .how-bullet-text { color:#475569; font-size:16px; line-height:26px; }
        .how-card { position:relative; background:#fff; border:1px solid #e5e7eb; border-radius:18px; box-shadow: 0 8px 18px rgba(0,0,0,0.06); padding:16px 18px; transition: transform .3s ease, box-shadow .3s ease, border-color .3s ease; }
        .how-card:hover { transform: translateY(-6px); box-shadow: 0 20px 40px rgba(238,0,0,0.12); border-color:#ee0000; }
        .how-icon-box { position:relative; width:44px; height:44px; border-radius:12px; display:flex; align-items:center; justify-content:center; background:#ee0000; color:#fff; border:2px solid #ee0000; flex-shrink:0; box-shadow:0 12px 24px -12px rgba(238,0,0,0.35); }
        .how-card-title { font-size:18px; font-weight:800; color:#111827; }
        .how-card-text { font-size:15px; color:#475569; line-height:26px; }
        @media (max-width: 992px) { .cmp-how-title { font-size: 40px; } }
        @media (max-width: 768px) { .cmp-how-title { font-size: 32px; } .how-bullet-text { font-size:15px; } }
        .cmp-teams-section { position: relative; padding: 80px 0; background: #fff; overflow: hidden; }
        .cmp-teams-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.25; pointer-events:none; z-index:0; }
        .cmp-teams-title { font-size:42px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px; }
        .cmp-teams-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px auto 0; width:0; }
        .team-card { position:relative; background:#fff; border:1px solid #e5e7eb; border-radius:22px; box-shadow: 0 8px 18px rgba(0,0,0,0.06); padding:18px; transition: transform .3s ease, box-shadow .3s ease, border-color .3s ease; }
        .team-card:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(238,0,0,0.15); border-color:#ee0000; }
        .team-item { display:flex; align-items:center; gap:10px; }
        .team-icon { width:32px; height:32px; border-radius:999px; display:flex; align-items:center; justify-content:center; background:#fff; border:2px solid #ee0000; color:#ee0000; flex-shrink:0; }
        .team-text { font-size:16px; color:#2d2d2d; font-weight:700; transition: color .3s ease; }
        .team-card:hover .team-text { color:#ee0000; }
        @media (max-width: 992px) { .cmp-teams-title { font-size: 40px; } }
        @media (max-width: 768px) { .cmp-teams-title { font-size: 32px; } .team-text { font-size:15px; } }
        .cmp-cta-section { position: relative; padding: 110px 0; background: #effdff; overflow: hidden; }
        .cmp-cta-grid { position:absolute; inset:0; background-image: radial-gradient(#eaeef5 1px, transparent 1px); background-size: 24px 24px; opacity:.2; pointer-events:none; z-index:0; }
        .cta-orb { position:absolute; border-radius:50%; filter: blur(100px); z-index:0; }
        .cta-orb-1 { top:-40px; left:-40px; width:500px; height:500px; background: rgba(238,0,0,0.10); animation: ctaOrbOne 8s ease-in-out infinite; }
        .cta-orb-2 { bottom:-60px; right:-60px; width:600px; height:600px; background: rgba(238,0,0,0.05); filter: blur(120px); animation: ctaOrbTwo 10s ease-in-out infinite; }
        @keyframes ctaOrbOne { 0% { transform: translate(0,0) scale(1); } 50% { transform: translate(50px,30px) scale(1.1); } 100% { transform: translate(0,0) scale(1); } }
        @keyframes ctaOrbTwo { 0% { transform: translate(0,0) scale(1); } 50% { transform: translate(-30px,-50px) scale(1.2); } 100% { transform: translate(0,0) scale(1); } }
        .cmp-cta-title { font-size:42px; font-weight:800; text-align:center; color:#0f172a; letter-spacing:-.5px; }
        .cmp-cta-text { font-size:18px; color:#475569; text-align:center; max-width:920px; margin: 10px auto 0; }
        .cmp-cta-underline { height:4px; background:#ee0000; border-radius:2px; margin:12px auto 0; width:0; }
        .cta-buttons { display:flex; gap:12px; justify-content:center; margin-top: 18px; flex-wrap:wrap; }
        .btn-cta-red, .btn-cta-white { display:inline-flex; align-items:center; gap:8px; padding:12px 22px; border-radius:999px; font-weight:800; transition: transform .2s ease, box-shadow .2s ease, background .2s ease, color .2s ease, border-color .2s ease; }
        .btn-cta-red { background:#ee0000; color:#fff; border:none; box-shadow:0 20px 40px -20px rgba(238,0,0,0.55); }
        .btn-cta-white { background:#fff; color:#ee0000; border:2px solid #ee0000; box-shadow:0 12px 24px -12px rgba(238,0,0,0.25); }
        .btn-cta-white:hover { background:#ee0000; color:#fff; }
        .btn-cta-red svg, .btn-cta-white svg { transition: transform .2s ease; }
        .btn-cta-red:hover svg, .btn-cta-white:hover svg { transform: translateX(4px); }
        .cta-badge { background: rgba(255,255,255,0.8); backdrop-filter: blur(6px); }
        @media (max-width: 992px) { .cmp-cta-title { font-size: 36px; } }
        @media (max-width: 768px) { .cmp-cta-title { font-size: 30px; } .cmp-cta-text { font-size:16px; } }
      `}</style>

      <section className="cmp-hero-section">
        <div className="cmp-grid"></div>
        <div className="cmp-orb cmp-orb-1"></div>
        <div className="cmp-orb cmp-orb-2"></div>
        <Container>
          <Row className="align-items-center justify-content-between position-relative" style={{ zIndex: 2 }}>
            <Col lg="7">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="pe-3"
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.2 }}
                  className="cmp-badge mb-3"
                >
                  <span className="cmp-badge-dot"></span> ENTERPRISE MIDDLEWARE
                </motion.div>
                <motion.h1
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                  className="cmp-title text-black mb-2"
                >
                  Enterprise Middleware Platform for <span className="cmp-highlight">Integration, Orchestration, and Data Modernization</span>
                </motion.h1>
                <motion.div
                  className="cmp-underline"
                  initial={{ width: 0 }}
                  animate={{ width: 160 }}
                  transition={{ delay: 0.2, duration: 0.8 }}
                />
                <p className="cmp-sub">Connect systems, orchestrate data, and scale securely with a centralized middleware layer.</p>
                <div className="cmp-buttons">
                  <Link to="/contact" style={{ textDecoration: 'none' }} className="btn-cmp-red">Get Started <ArrowRight size={18} /></Link>
                  <Link to="/contact" style={{ textDecoration: 'none' }} className="btn-cmp-white">View Documentation <ArrowRight size={18} /></Link>
                </div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="cmp-desc-box"
                >
                  The Custom Middleware Platform is an enterprise-grade integration and orchestration layer that enables secure, reliable communication across APIs, databases, file systems, cloud services, and third-party platforms. It abstracts integration complexity, decouples systems, and provides a centralized foundation for scalable, future-ready enterprise architectures.
                </motion.div>
              </motion.div>
            </Col>
            <Col lg="5" className="text-center">
              <div className="hero-media m-auto" style={{ width: "90%" }}>
                <Image src={flutterHero} alt="CMP hero" className="w-100" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>





      <section className="cmp-overview-section">
        <div className="cmp-overview-grid"></div>
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4 }}
              className="cmp-badge mb-3"
            >
              <span className="cmp-badge-dot"></span> OVERVIEW
            </motion.div>
            <motion.h2
              className="cmp-overview-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              What Is the Custom Middleware Platform?
            </motion.h2>
            <motion.div
              className="cmp-overview-underline"
              initial={{ width: 0 }}
              whileInView={{ width: 140 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.5 }}
            />

            <motion.p
              className="cmp-overview-text"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              Custom Middleware Platform functions as a central mediation and orchestration layer between disparate enterprise systems. It enables organizations to move away from fragile point-to-point integrations by providing a unified layer for connectivity, transformation, governance, and observability.
            </motion.p>
            <motion.p
              className="cmp-overview-text"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              It supports both real-time and batch integrations, allowing enterprises to modernize legacy systems, unify data flows, and scale digital initiatives without rewriting existing applications.
            </motion.p>
          </div>
        </Container>
      </section>

      <section className="cmp-highlights-section">
        <div className="cmp-highlights-grid"></div>
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="cmp-badge mb-3"
              >
                <span className="cmp-badge-dot"></span> KEY HIGHLIGHTS
              </motion.div>
              <motion.h2
                className="cmp-highlights-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                Key Highlights
              </motion.h2>
            </motion.div>
          </div>
          <Row className="highlight-row" style={{ position: 'relative', zIndex: 2 }}>
            {[
              'Secure API orchestration and governance',
              'System-to-system integrations across heterogeneous environments',
              'Real-time and batch data pipelines',
              'Centralized monitoring, control, and observability',
              'Extensible architecture for rapid onboarding of new systems',
            ].map((text, i) => (
              <Col key={text} lg={4} md={6} sm={12} className="mb-3 d-flex">
                <motion.div
                  className="highlight-card w-100"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  whileHover={{ y: -8, scale: 1.02 }}
                >
                  <div className="highlight-item">
                    <div className="highlight-icon">
                      <CheckCircle2 size={18} />
                    </div>
                    <div className="highlight-text">{text}</div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="cmp-why-section">
        <div className="cmp-why-grid"></div>
        <Container>
          <div className="position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="cmp-badge mb-3"
            >
              <span className="cmp-badge-dot"></span> WHY CHOOSE US
            </motion.div>
            <motion.h2
              className="cmp-why-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Why Custom Middleware Platform?
            </motion.h2>
            <motion.p
              className="cmp-why-text mt-3"
              style={{ textAlign: 'center' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Modern enterprises operate across dozens of disconnected systems—CRMs, databases, marketing platforms, analytics tools, legacy applications, and file-based integrations. Managing these systems through direct point-to-point connections results in brittle architectures that are difficult to scale, monitor, and evolve.
            </motion.p>
            <motion.p
              className="cmp-why-text mt-3"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              The Custom Middleware Platform acts as a central integration hub, ensuring consistent, secure, and observable data movement while insulating core systems from change. This enables faster innovation, reduced operational risk, and long-term architectural flexibility.
            </motion.p>
          </div>
        </Container>
      </section>

      <section className="cmp-benefits-section">
        <div className="cmp-benefits-grid"></div>
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4 }}
              className="cmp-badge mb-3"
            >
              <span className="cmp-badge-dot"></span> BENEFITS
            </motion.div>
            <motion.h2
              className="cmp-benefits-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Core Benefits
            </motion.h2>

          </div>

          <Row className="mt-4" style={{ position: 'relative', zIndex: 2 }}>
            {[
              {
                icon: Shield,
                title: 'Enterprise-Grade Security',
                text: 'Built-in authentication, authorization, encryption, and policy controls ensure secure data exchange across systems and environments.'
              },
              {
                icon: Zap,
                title: 'Faster Integrations',
                text: 'Pre-built connectors, reusable workflows, and configuration-driven orchestration significantly reduce development effort and time to deployment.'
              },
              {
                icon: Activity,
                title: 'Scalable by Design',
                text: 'Supports high-throughput workloads, large datasets, and growing ecosystems with predictable performance and resilience.'
              },
              {
                icon: BarChart3,
                title: 'Complete Visibility',
                text: 'End-to-end monitoring, logging, retries, and alerts provide full operational transparency across all integration flows.'
              }
            ].map((item, i) => (
              <Col key={item.title} lg={3} md={6} sm={12} className="mb-3 d-flex">
                <motion.div
                  className="benefit-card w-100"
                  style={{ transformPerspective: 1000 }}
                  initial={{ opacity: 0, y: 40, rotateX: -15 }}
                  whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
                  viewport={{ once: true }}
                  transition={{ type: 'spring', stiffness: 80, damping: 20, duration: 0.6, delay: i * 0.1 }}
                  whileHover={{ y: -10, scale: 1.02 }}
                >
                  <div className="d-block align-items-start" style={{ gap: 14 }}>
                    <motion.div
                      className="benefit-icon"
                      whileHover={{ rotate: 360 }}
                      transition={{ duration: 0.6 }}
                    >
                      {React.createElement(item.icon, { size: 20 })}
                    </motion.div>
                    <div>
                      <div className="benefit-title">{item.title}</div>
                      <div className="benefit-text">{item.text}</div>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <section className="cmp-connectors-section">
        <div className="cmp-connectors-grid"></div>
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="cmp-badge mb-3"
              >
                <span className="cmp-badge-dot"></span> CONNECTORS
              </motion.div>
              <motion.h2
                className="cmp-connectors-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                Pre-Built Connectors
              </motion.h2>
            </motion.div>
          </div>

          <Row className="g-4 mt-2" style={{ position: 'relative', zIndex: 2 }}>
            {[
              {
                icon: Folder,
                title: 'File & Storage',
                chips: ['SFTP', 'FTP', 'AWS S3', 'Google Cloud Storage', 'Azure Storage', 'CSV files']
              },
              {
                icon: Megaphone,
                title: 'Marketing Platforms',
                chips: ['Netcore', 'Acoustic']
              },
              {
                icon: Database,
                title: 'Databases & Data Platforms',
                chips: ['MySQL', 'PostgreSQL', 'SQL Server', 'DB2', 'Redshift', 'BigQuery', 'Databricks']
              },
              {
                icon: ShoppingCart,
                title: 'Business, CRM & Commerce',
                chips: ['Salesforce CRM', 'Odoo', 'Shopify', 'Magento', 'BI Platforms']
              },
              {
                icon: BarChart3,
                title: 'Analytics & Advertising',
                chips: ['Google Analytics', 'Google Ads', 'Meta Ads']
              },
              {
                icon: Globe,
                title: 'Enterprise & Ecosystem',
                chips: ['Tata Digital', 'Locobuzz', 'Litmus', 'Navitor']
              }
            ].map((item, i) => (
              <Col key={item.title} lg={4} md={6} sm={12} className="d-flex">
                <motion.div
                  className="connector-card w-100 h-100"
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  whileHover={{ y: -5 }}
                >
                  <div className="d-flex align-items-start" style={{ gap: 14 }}>
                    <div className="connector-icon-box">
                      {React.createElement(item.icon, { size: 24 })}
                    </div>
                    <div className="flex-grow-1">
                      <div className="connector-title">{item.title}</div>
                      <div className="connector-chip-row">
                        {item.chips.map((c) => (
                          <span key={c} className="connector-chip">{c}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-4 position-relative" style={{ zIndex: 2 }}>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.8 }}
              style={{ color: '#475569', fontSize: 16 }}
            >
              Need a new connector? The platform is extensible and designed to onboard new systems rapidly.
            </motion.p>
          </div>
        </Container>
      </section>

      <section className="cmp-usecases-section">
        <div className="cmp-usecases-grid"></div>
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="cmp-badge mb-3"
              >
                <span className="cmp-badge-dot"></span> USE CASES
              </motion.div>
              <motion.h2
                className="cmp-usecases-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                Use Cases
              </motion.h2>
            </motion.div>

          </div>

          <Row className="g-4 mt-2" style={{ position: 'relative', zIndex: 2 }}>
            {[
              {
                icon: Users,
                title: 'CRM & Marketing Synchronization',
                text: 'Keep customer profiles, campaign data, and engagement metrics consistent across platforms.'
              },
              {
                icon: BarChart3,
                title: 'Analytics & Data Warehousing',
                text: 'Stream operational and marketing data into centralized warehouses for reporting, BI, and advanced analytics.'
              },
              {
                icon: ShoppingCart,
                title: 'E-commerce Integrations',
                text: 'Unify orders, customers, and transactions across commerce platforms, CRM systems, and BI tools.'
              },
              {
                icon: Lock,
                title: 'Secure File-Based Exchanges',
                text: 'Automate partner and vendor data exchange using SFTP, FTP, and cloud storage integrations.'
              },
              {
                icon: Server,
                title: 'Legacy System Modernization',
                text: 'Expose legacy systems through modern APIs without refactoring or rewriting existing applications.'
              }
            ].map((item, i) => (
              <Col key={item.title} lg={4} md={6} sm={12} className="d-flex">
                <motion.div
                  className="usecase-card w-100 h-100"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                  whileHover={{ y: -8, scale: 1.02 }}
                >
                  <div className="d-flex align-items-start" style={{ gap: 14 }}>
                    <div className="usecase-icon-container">
                      <div className="usecase-icon-glow"></div>
                      <motion.div
                        className="usecase-icon-box"
                        whileHover={{ rotate: 360, scale: 1.1 }}
                        transition={{ duration: 0.6 }}
                      >
                        {React.createElement(item.icon, { size: 24 })}
                      </motion.div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="usecase-title">{item.title}</div>
                      <div className="usecase-text">{item.text}</div>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      <section className="cmp-how-section">
        <div className="cmp-how-grid"></div>
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="cmp-badge mb-3"
              >
                <span className="cmp-badge-dot"></span> HOW IT WORKS
              </motion.div>
              <motion.h2
                className="cmp-how-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                How It Works
              </motion.h2>
            </motion.div>

          </div>

          <motion.div
            className="mt-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            style={{ position: 'relative', zIndex: 2 }}
          >
            <div className="how-diagram">
              <div className="how-box">Source Systems</div>
              <div className="how-arrow">→</div>
              <div className="how-box-mid">Custom Middleware Platform</div>
              <div className="how-arrow">→</div>
              <div className="how-box">Target Systems</div>
            </div>
          </motion.div>

          <Row className="g-3 mt-3 position-relative" style={{ zIndex: 2 }}>
            {[
              { icon: Activity, title: 'API Orchestration', text: 'Orchestrates synchronous and asynchronous API interactions' },
              { icon: Database, title: 'Data Transformation', text: 'Transforms, validates, and routes data across systems' },
              { icon: Shield, title: 'Exception Management', text: 'Handles failures, retries, and exception management' },
              { icon: Lock, title: 'Security & Governance', text: 'Enforces security, governance, and access controls' },
              { icon: BarChart3, title: 'Centralized Observability', text: 'Provides centralized observability and operational insight' },
            ].map((item, i) => (
              <Col key={item.title} lg={4} md={6} sm={12}>
                <motion.div
                  className="how-card"
                  initial={{ opacity: 0, y: 20, x: -10 }}
                  whileInView={{ opacity: 1, y: 0, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.8 + i * 0.1 }}
                  whileHover={{ y: -6 }}
                >
                  <div className="d-flex align-items-start" style={{ gap: 14 }}>
                    <div className="how-icon-box">
                      {React.createElement(item.icon, { size: 20 })}
                    </div>
                    <div className="flex-grow-1">
                      <div className="how-card-title">{item.title}</div>
                      <div className="how-card-text">{item.text}</div>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>

          <motion.p
            className="mt-5"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 1.3 }}
            style={{ textAlign: 'center', color: '#111827', fontWeight: 800 }}
          >
            All integrations are managed through a single, unified orchestration layer.
          </motion.p>
        </Container>
      </section>


      <section className="cmp-teams-section">
        <div className="cmp-teams-grid"></div>
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="cmp-badge mb-3"
              >
                <span className="cmp-badge-dot"></span> FOR TEAMS
              </motion.div>
              <motion.h2
                className="cmp-teams-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                Built for Teams That Scale
              </motion.h2>
            </motion.div>

          </div>

          <Row className="g-4 mt-2" style={{ position: 'relative', zIndex: 2 }}>
            {[
              'Developer-friendly APIs and SDKs',
              'Configuration-driven integrations',
              'Minimal custom code requirements',
              'Rapid onboarding of new systems',
              'Designed for long-term maintainability and evolution',
            ].map((text, i) => (
              <Col key={text} lg={4} md={6} sm={12} className="d-flex">
                <motion.div
                  className="team-card w-100 h-100 group"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  whileHover={{ y: -8 }}
                >
                  <div className="team-item">
                    <div className="team-icon"><CheckCircle2 size={20} /></div>
                    <div className="team-text">{text}</div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="cmp-cta-section">
        {/* <div className="cmp-cta-grid"></div>
        <div className="cta-orb cta-orb-1"></div>
        <div className="cta-orb cta-orb-2"></div> */}
        <Container>
          <div className="text-center position-relative" style={{ zIndex: 2 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="cmp-badge cta-badge mb-3"
              >
                <span className="cmp-badge-dot"></span> GET STARTED
              </motion.div>
              <motion.h2
                className="cmp-cta-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                Ready to Simplify Your Integrations?
              </motion.h2>
            </motion.div>

            <motion.p
              className="cmp-cta-text"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Build reliable, secure, and scalable enterprise integrations without fragile point-to-point connections. Modernize your architecture with a middleware layer designed for scale.
            </motion.p>
            <motion.div
              className="cta-buttons"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <motion.div whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.98 }}>
                <Link to="/contact" style={{ textDecoration: 'none' }} className="btn-cta-red">Request Demo <ArrowRight size={18} /></Link>
              </motion.div>
              <motion.div whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.98 }}>
                <Link to="/contact" style={{ textDecoration: 'none' }} className="btn-cta-white">Contact Sales <ArrowRight size={18} /></Link>
              </motion.div>
            </motion.div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default CustomMiddlewarePlatform;
